import type { ExperimentalMutations } from '../__types__/ExperimentalMutations'; //eslint-disable-line no-restricted-imports
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalUpdateAutomationRuleWithConnection: ExperimentalMutations['experimentalUpdateAutomationRuleWithConnection'] =
	(_, { cloudId, spaceId, automationStack, ruleId, ruleConfig, connections }, { network }) =>
		fetchJSON(
			network,
			`/gateway/api/automation/internal-api/confluence/${cloudId}/${automationStack}/rest/${spaceId}/rule/${ruleId}`,
			{
				method: 'PUT',
				credentials: 'include',
				body: JSON.stringify({
					newConnections: connections,
					ruleConfigBean: ruleConfig,
				}),
				headers: {
					'Content-Type': MediaType.JSON,
				},
			},
		).then((response) => {
			return {
				id: response.ruleConfigBean.id,
				idUuid: response.ruleConfigBean.idUuid,
				state: response.ruleConfigBean.state,
			};
		});
